// TODO: Remove from `core-js@4`
require('./es.symbol.match-all');

require('./es.string.match-all');